module.exports = __webpack_public_path__ + "img/LADY HAT LIME.58fec3f.svg";